function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterWell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    viewBox: "0 0 511.996 511.996",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.002 333.654-27.719 10.828-27.719-10.828-10.136-62.125 37.855-14.486 37.855 14.486z",
    style: {},
    fill: "#fced7e",
    "data-original": "#fced7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.564 333.654-10.136-62.125 22.855-8.746-15-5.74-37.855 14.486 10.136 62.125 27.719 10.828 15-5.86z",
    style: {},
    fill: "#fcdf51",
    "data-original": "#fcdf51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.91 100.268h31.062v248.676H38.91zM380.594 100.268h31.062v248.676h-31.062z",
    style: {},
    fill: "#d98f61",
    "data-original": "#d98f61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.719 116.218H7.847L69.972 7.5h310.622z",
    style: {},
    fill: "#bd6629",
    "data-original": "#bd6629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.972 7.5 7.847 116.218h30L99.972 7.5z",
    style: {},
    fill: "#a45924",
    "data-original": "#a45924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.188 411.573v-46.594l-46.594-12.613-54.359 12.613-8.738 38.85-54.359 7.744v46.593l54.359 7.95 8.738 38.38h100.953v-46.593l-46.594-8.117v-31.535zM111.678 399.105l-54.359 12.468v46.593l51.544 13.581 15.468 32.749h100.952l10.581-46.593-54.359-9.244v-28.156l54.359-8.93-10.581-46.594-51.099-12.613-49.853 12.613z",
    style: {},
    fill: "#9bb9c3",
    "data-original": "#9bb9c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.597 178.342H107.969a6.935 6.935 0 0 1-6.935-6.935v-17.193a6.935 6.935 0 0 1 6.935-6.935h234.628a6.935 6.935 0 0 1 6.935 6.935v17.193a6.934 6.934 0 0 1-6.935 6.935z",
    style: {},
    fill: "#d98f61",
    "data-original": "#d98f61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.034 171.408v-17.193a6.935 6.935 0 0 1 6.935-6.935h-30a6.935 6.935 0 0 0-6.935 6.935v17.193a6.935 6.935 0 0 0 6.935 6.935h30a6.936 6.936 0 0 1-6.935-6.935z",
    style: {},
    fill: "#d37f50",
    "data-original": "#d37f50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.748 242.558h97.07v28.972h-97.07z",
    style: {},
    fill: "#ffcf64",
    "data-original": "#ffcf64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.748 242.558h30v28.972h-30z",
    style: {},
    fill: "#ffc251",
    "data-original": "#ffc251"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.965,
    cy: 225.684,
    r: 15.184,
    style: {},
    fill: "#fced7e",
    "data-original": "#fced7e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.331 364.979-11.123 30h118.888l-6.813-30-4.303-1.062-46.796-11.551zM326.235 364.979l-6.747 30h107.7v-30l-3.924-1.062h-92.451z",
    style: {},
    fill: "#8baab2",
    "data-original": "#8baab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.829 411.573h54.359v46.593h-54.359zM23.378 504.496h100.953v-46.593H69.972v-46.33h54.359v-46.594l-50.476-10.361-50.477 10.361zM225.283 411.573h-54.359v46.593h54.359v46.33h100.952v-46.593h-54.358v-46.33h54.358v-46.594l-48.437-10.361-52.515 10.361z",
    style: {},
    fill: "#607882",
    "data-original": "#607882"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.331 364.979-35.476-7.282-15-3.079-50.477 10.361v139.517h30V394.979h70.953zM225.283 364.979v30h100.952v-30l-4.965-1.062-43.472-9.299z",
    style: {},
    fill: "#526970",
    "data-original": "#526970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.847 333.917h434.872v31.062H7.847z",
    style: {},
    fill: "#9bb9c3",
    "data-original": "#9bb9c3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.847 333.917h30v31.062h-30z",
    style: {},
    fill: "#8baab2",
    "data-original": "#8baab2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.719 116.218H7.847L69.972 7.5h310.622zM38.91 116.218h31.062v217.699H38.91zM380.594 254.946V116.218h31.063v217.699h-31.063v-46.31M154.581 364.98H7.847v-31.063h434.872v31.063H187.428M23.378 364.98H124.33v46.593H23.378zM225.283 364.98v46.593H124.331V364.98M225.283 364.98h100.952v46.593H225.283zM326.235 364.98h100.952v46.593H326.235zM23.378 457.903H124.33v46.593H23.378zM124.331 457.903h100.952v46.593H124.331z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.283 457.903h100.952v46.593H225.283zM326.235 457.903h100.952v46.593H326.235zM69.972 411.573h100.952v46.593H69.972zM23.378 411.573h46.593v46.593H23.378z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.924 411.573h100.952v46.593H170.924zM271.876 411.573h100.952v46.593H271.876zM372.829 411.573h54.359v46.593h-54.359zM342.597 178.342H107.969a6.935 6.935 0 0 1-6.935-6.935v-17.193a6.935 6.935 0 0 1 6.935-6.935h234.628a6.935 6.935 0 0 1 6.935 6.935v17.193a6.934 6.934 0 0 1-6.935 6.935zM69.972 162.811h31.062M350.362 162.811h30.232M225.283 178.444v64.114M253.002 333.654h-55.438l-10.136-62.125h75.71z",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.748 242.558h97.07v28.972h-97.07zM163.159 147.28v31.062M132.096 147.28v31.062M194.221 147.28v31.062M225.283 147.28v31.062M256.345 147.28v31.062M287.408 147.28v31.062M416.582 162.811h26.137v62.257h31.062",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 488.965,
    cy: 225.684,
    r: 15.184,
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.346 7.5 69.972 116.218M141.406 78.202l-9.31 38.016M158.721 7.5l-9.31 38.016M203.096 7.5l-8.875 108.718M247.47 7.5l8.875 108.718M291.845 7.5l26.625 108.718M336.22 7.5l44.374 108.718M318.47 147.28v31.062",
    style: {
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#000000",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterWell);
export default __webpack_public_path__ + "static/media/waterWell.45bb25f987c5114463f0999e4c0cd075.svg";
export { ForwardRef as ReactComponent };